import { HelpCircle } from 'lucide-react';
import { Dialog, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DialogContentSafeArea } from '@/components/ui/dialog-safe-area';
import { Button } from '@/components/ui/button';
import { KontentinoPromoCard } from '../KontentinoPromoCard';

interface HelpDialogProps {
  open: boolean;
  onClose: () => void;
}

export function HelpDialog({open, onClose}: HelpDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContentSafeArea className="sm:max-w-lg max-h-[85vh] overflow-y-auto [scrollbar-gutter:stable]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <HelpCircle className="h-5 w-5 text-primary"/>
            Calendar Tips & Help
          </DialogTitle>
          <DialogDescription>
            Learn how to make the most of your content calendar
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex gap-2">
              <div className="flex-shrink-0">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="text-xs font-semibold text-primary">1</span>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1 text-sm">Drag & Drop</h3>
                <p className="text-xs text-muted-foreground">
                  Drag posts to reschedule. Changes are temporary.
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <div className="flex-shrink-0">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="text-xs font-semibold text-primary">2</span>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1 text-sm">Click to Preview</h3>
                <p className="text-xs text-muted-foreground">
                  View full details with platform preview. Use arrows to browse.
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <div className="flex-shrink-0">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="text-xs font-semibold text-primary">3</span>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1 text-sm">Export Formats</h3>
                <p className="text-xs text-muted-foreground">
                  PDF for approvals, PNG for presentations, CSV for data.
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <div className="flex-shrink-0">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <span className="text-xs font-semibold text-primary">4</span>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-foreground mb-1 text-sm">PDF Workflow</h3>
                <p className="text-xs text-muted-foreground">
                  PDFs include fillable checkboxes and comment fields.
                </p>
              </div>
            </div>
          </div>

          <KontentinoPromoCard className="mt-6" />

          <div className="pt-4 border-t">
            <Button
              variant="outline"
              className="w-full"
              onClick={onClose}
            >
              Got it!
            </Button>
          </div>
        </div>
      </DialogContentSafeArea>
    </Dialog>
  );
}
